import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllPropertyGroups = () => createGetAllMethod(entityType)
export const deletePropertyGroup = (payload) => createDeleteMethod(entityType, payload)
export const createPropertyGroup = (payload) => createPostMethod(entityType, payload)
export const updatePropertyGroup = (payload) => createPutMethod(entityType, payload)
